import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "es",
  setLang: () => {},
  t: translations.es,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") {
      return window.localStorage.getItem("wedding_lang") || "es";
    }
    return "es";
  });

  const setLang = (next) => {
    setLangState(next);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("wedding_lang", next);
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
